import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import toggle from '../helpers/class-toggle';
import { Splide } from '@splidejs/splide';
// import idx from '../helpers/idx';

export default () => {
	const popup = document.querySelector('.gallery');

	if (!popup) {return}
	
	const sliderPrefix = 'gallery__';
	const tabsEl = document.querySelector(`.${sliderPrefix}tabs`);
	const buttons = document.querySelectorAll('.gallery__thumb');
	const btnClose = document.querySelector('.js-close-gallery');
	const body = document.body;
	const images = popup.querySelectorAll('img[data-src]');

	const SLIDE_SPEED = 800;
	const BTN_ACTIVE = 'contact__btn--active';


	const openButtons = document.querySelectorAll('.js-open-gallery');

	if (openButtons.length) {
		openButtons.forEach(function(btn) {
			btn.addEventListener('click', (e) => {
				loadImages(images);

				const index = +btn.dataset.index || 0;
				// console.log({index});

				gotoSlide(index, false);

				popup.classList.add('gallery--visible');
				body.classList.add('is-popup-opened');
			});

			btn.addEventListener('mouseenter', (e) => {
				setTimeout(function(){
					loadImages(images);
				}, 300);
			});
		});
	}

	if (btnClose && popup) {
		btnClose.addEventListener('click', (e) => {
			e.preventDefault();

			popup.classList.remove('gallery--visible');
			body.classList.remove('is-popup-opened');
		});
	}

	popup.addEventListener('click', (e) => {
		if (!e.target.closest('.gallery__thumb')) {
			popup.classList.remove('gallery--visible');
			body.classList.remove('is-popup-opened');
		}
	});



	// let currentSlide;
	let thumbs = document.querySelectorAll('.gallery__thumb');

	function loadImages(images) {
		images.forEach(function(image) {
			if (!image.classList.contains('loaded')) {
				image.src = image.dataset.src;
				image.classList.add('loaded');
			}
		});
	}


	let sliderScroller = document.querySelector('.gallery__slider');
	let sliderTrack = document.querySelector('.gallery .splide__track');

	// console.log(sliderScroller, sliderTrack);

	// watchGallerySCroll
	ScrollTrigger.create({
		trigger: sliderTrack,
		scroller: sliderScroller,
		start: 'top top',
		end: 'bottom bottom',
		onUpdate: function(self) {
			const progress = self.progress*99;
			// console.log('Scroll progress:', progress);
			toggleActiveThumb(thumbs, 'gallery__thumb--active', progress);
		}
	});


	function toggleActiveThumb(elements, className, progress) {
		const totalItems = elements.length;
		const threshold = 100 / totalItems;

		elements.forEach((element, index) => {
			const start = index * threshold;
			const end = (index + 1) * threshold;

			if (progress >= start && progress < end) {
				element.classList.add(className);
			} else {
				element.classList.remove(className);
			}
		});
	}


	// return;

	let slider = document.querySelector('.gallery__slider');
	const splideSlider = new Splide(slider, {
		focus  : 'center',
		direction: 'ttb',
		speed: 700,
		arrows: false,
		pagination: false,
		destroy: true, // todo: remove
		height: '100%',
		wheel: true,
		wheelSleep: 750,
		drag: 'free',
		mediaQuery: 'max',
		breakpoints: {
			// 1023: {
			// 	height: 'auto',
			// 	autoHeight: true,
			// 	wheel: false,
			// },
			743: {
				direction: 'ltr',
				drag: true,
				autoHeight: false,
				wheel: false,
				destroy: false,
			},
			
		}
	}).mount();

	splideSlider.on('active', (e)=> {
		// console.log(e);
		toggle(thumbs, thumbs[e.index], 'gallery__thumb--active');
	});

	thumbs.forEach(function(thumb, index) {
		thumb.addEventListener('click', (e) => {
			e.preventDefault();
			
			gotoSlide(index);
		});
	});

	function gotoSlide(index, smooth = true){
		// console.log('gotoSlide ', index);
		let isMobile = false;

		if (window.innerWidth <= 743) {
			isMobile = true;
		}
		const duration = 1;
		const ease = 'power3.out';


		if (isMobile) {
			splideSlider.go(index);
		} else {
			const slides = document.querySelectorAll('.gallery__slide');
			const targetSlide = slides[index];
			const scroller = document.querySelector('.gallery__slider');

			if (!scroller || !targetSlide) return;

			let targetPosition = targetSlide.offsetTop;
			let offset = {};
			offset.val = scroller.scrollTop;

			if (smooth == true) {
				gsap.to(offset, {
					val: targetPosition,
					duration: duration,
					ease: ease,
					onUpdate: () => {
						scroller.scrollTo(0, offset.val);
					}
				});
			} else {
				scroller.scrollTo(0, targetPosition);
			}
		}
	}
}